var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav_menu"},[_c(_vm.CurrentNav,{tag:"component",attrs:{"navData":_vm.NavData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }